import styled from "styled-components";
import { BodyDefault, BodyMedium } from "../typography/styled";

type ItemProp = {
  withIcon?: boolean;
  isTutorial?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 50px 30px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    padding: 10px 16px 32px;
  }
`

export const PageHeader = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }
`

export const PageHeaderInfo = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex: 1 1 100%;
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }
`

export const PageHeaderActions = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    width: 100%;

    > button {
      flex: 1 1 auto;
    }
  }
`

export const ResourceActions = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;

  > button {
    flex: 0 0 auto;
    margin: 0 !important;
  }

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
    margin: 12px 0 16px;

    > button {
      flex: 0 0 auto;
      align-self: flex-start;
      margin: 0 !important;
    }

    > div {
      flex: 1 1 140px;
      width: auto !important;
      min-width: 0;
      flex-wrap: wrap;
      gap: 8px;
    }

    > div > div:first-child {
      min-width: 0;
      flex-wrap: wrap;
    }
  }
`

export const EmptyActions = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;
  }
`

export const TutorialGrid = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  margin-top: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const TutorialColumn = styled.div`
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0 !important;
  }
`


export const TutorItem = styled.div<ItemProp>`
  box-sizing: border-box;
  background:${({theme}) => theme.palette[100]};
  border-radius: 8px;
  display: flex;
  /* width: 100%; */
  padding:${({withIcon}) => withIcon ? '14px 20px 14px 20px' : "14px 20px 14px 20px"};
  overflow: hidden;
  /* flex: none; */
  position: relative;
  flex-grow: 1;
  gap:8px;
  @media screen and (max-width: 1000px) {
    background-size:0%;
  }

  &:hover {
    cursor: ${({isTutorial}) => !isTutorial ? '' : 'pointer'};
    background: ${({theme, isTutorial}) => !isTutorial ? '' : theme.isDark ? theme.palette[200] : theme.grey[200]};
  }

  @media (max-width: 768px) {
    width: 100%;
  }

`
export const TutorTitle = styled(BodyMedium)`
  color:${({theme}) => theme.accent[100]};
  margin-bottom:4px;
`

export const TutorTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const TutorContent = styled(BodyDefault)`
  color:${({theme}) => theme.palette[650]};
`
export const TutorIcon = styled.img`

`
export const TutorIconBack = styled.img`
  top:16px;
  position: absolute;
  width: 88px;
  height: 88px;
  right:34px;
  /* bottom:-12px; */
`
